export const STRINGS = {
    ADD: "Add",
    EDIT: "Edit",
    DELETE: "Delete",
    USER: "User",
    CANCEL: "Cancel",
    CONFIRM: "Confirm",
    SAVE: "Save",
    CLOSE: "Close",
    ACTIONS: "Actions",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    STATUS: "Status",
    DELETE_CONFIRMATION: "Do you really want to delete",
    SEND: "Send",
    SEARCH: "Search",
    FILTER: "Filter",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    NO_RESULTS: "No Results Found",
};

export const SIZES = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    GROW: "grow",
    AUTO: "auto",
};

export const COLORS = {
    GREEN: "rgb(46, 125, 50)",
    RED: "rgb(211, 47, 47)",
};

export const VARIANTS = {
    CONTAINED: "contained",
    OUTLINED: "outlined",
    TEXT: "text",
    BODY: "body",
    BODY2: "body2",
    CAPTION: "caption",
    PRIMARY: "primary",
};

export const TYPES = {
    NUMBER: "number",
};

export const STATUS = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info"
};

export const BUTTON_COLORS = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    ERROR: "error",
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning"
};

export const ICON_POSITIONS = {
    START: "start",
    END: "end",
    TOP: "top",
    BOTTOM: "bottom"
};

export const SORT_ORDERS = {
    ASCENDING: "asc",
    DESCENDING: "desc"
};

export const ALIGN = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};

export const FLEX_DIRECTIONS = {
    COLUMN: "column",
    ROW: "row",
}

export const DISPLAY = {
    FLEX: "flex",
    BLOCK: "block",
}

export const WIDTH = {
    FULL: "100%",
};

export const FONT_WEIGHT = {
    F600: "600",
    NORMAL: "normal",
};

export const TYPOGRAPHY_VARIANT = {
    H6: "h6",
};

export const HTML_TAGS = {
    DIV: "div",
};

export const AUTO_COMPLETE = {
    OFF: "off",
};